import request from '../utils/request'

export function getCompetitionRegions() {
  return request({
    url: '/api/admin/competition/regions',
    method: 'get'
  })
}

export function getCompetitionEvents(params) {
  return request({
    url: '/api/admin/competition/events',
    method: 'get',
    params
  })
}

export function getCompetitionEvent(id) {
  return request({
    url: `/api/admin/competition/events/${id}`,
    method: 'get'
  })
}

export function createCompetitionEvent(data) {
  return request({
    url: '/api/admin/competition/events',
    method: 'post',
    data
  })
}

export function updateCompetitionEvent(id, data) {
  return request({
    url: `/api/admin/competition/events/${id}`,
    method: 'put',
    data
  })
}

export function publishCompetitionEvent(id) {
  return request({
    url: `/api/admin/competition/events/${id}/publish`,
    method: 'post'
  })
}

export function offlineCompetitionEvent(id) {
  return request({
    url: `/api/admin/competition/events/${id}/offline`,
    method: 'post'
  })
}

export function getCompetitionRegistrations(params) {
  return request({
    url: '/api/admin/competition/registrations',
    method: 'get',
    params
  })
}

export function acceptCompetitionRegistration(id, data) {
  return request({
    url: `/api/admin/competition/registrations/${id}/accept`,
    method: 'post',
    data
  })
}

export function rejectCompetitionRegistration(id, data) {
  return request({
    url: `/api/admin/competition/registrations/${id}/reject`,
    method: 'post',
    data
  })
}
